(() => {
  "use strict";

  function linkParamHandler() {
    const bingParamList = [
      "custom",
      "custom7",
      "custom8",
      "tg3",
      "tg7",
      "tg9",
      "tg5",
      "ctx",
    ];

    let urlHref = window.location.href;
    let urlHostName = window.location.hostname;
    let url = new URL(urlHref);
    let utmMedium = url.searchParams.get("utm_medium");
    let tg5 = url.searchParams.get("tg5");
    let tg7 = urlHostName;
    let tg8 = url.searchParams.get("tg8");
    let tg9 = url.searchParams.get("tg9");

    let ctx = url.searchParams.get("ctx");

    let links = document.querySelectorAll(
      ".link-ads, .river-link, .litem-link6879, .link-item12, .itemurllink, .item-link2023, .item-link9876, .adz-button-link-3434, .link-item35, .link-ads2344, .river-link, .link-item24, .item-link5678, .link-item14, .adz-item5678, .link-ads234, .link-item2268, .link-adzz, .link-item1268, .adz-item-234765, .link-item46, .link-ads, .item345-link, .link-class, .link-ads23, .adz-item8765, .adz-button, .link-ads22, .adz-button-27864",
    );

    for (let i = 0; i < links.length; i++) {
      // Get the complete link.
      let href = links[i].href;
      href = href.replace(/\s+/g, "");

      // Get the link without the parameters.
      let cleanHref = href.split("?")[0];

      let link = new URL(href);
      let linkParams = new URLSearchParams(link.searchParams);

      // Set the parameters in the array from the URL in the link.
      bingParamList.forEach(function (key) {
        switch (key) {
          case "custom":
            if (
              window.location.pathname.includes("your-guide-feedback") &&
              utmMedium.includes("guide")
            ) {
              // Changes the utm_medium param when it the user lands in the review page.
              linkParams.set(
                "custom",
                "bing_" + utmMedium.replace("guide", "review"),
              );
            } else if (
              window.location.pathname.includes("getting-your-guide")
            ) {
              // Changes the subid to cao_thank_bing for thank you pages that are part of the path or vector flow.
              linkParams.set("custom", "cao_thank_bing");
            } else if ("undefined" != typeof tg8) {
              linkParams.set("custom", "bing_" + utmMedium + tg8);
            } else {
              linkParams.set("custom", "bing_" + utmMedium);
            }
            break;
          case "custom7":
            linkParams.set("custom7", utmMedium);
            break;
          case "custom8":
            linkParams.set("custom8", urlHostName);
            break;
          case "tg3":
            linkParams.set("tg3", utmMedium);
            break;
          case "tg5":
            if (tg5) {
              linkParams.set("tg5", tg5);
            } else if (ctx) {
              if (!ctx.startsWith("vec_")) {
                linkParams.set("tg5", "vec_" + ctx);
              } else {
                linkParams.set("tg5", ctx);
              }
            }
            break;
          case "tg7":
            if (tg7) {
              linkParams.set("tg7", tg7);
            }
            break;
          case "tg9":
            linkParams.set("tg9", tg9);

            // let tg9Value = tg9 ? tg9 : urlHostName;
            // linkParams.set( 'tg9', tg9Value );
            break;
        }
      });
      let newParams = linkParams.toString();

      // Form the new link.
      links[i].setAttribute("href", cleanHref + "?" + newParams);
    }
  }

  // Define parameters to work
  const paramList = [
    "trkid",
    "ctx",
    "cka",
    "cko",
    "cks1",
    "cks2",
    "cks3",
    "cks4",
    "first",
    "first_name",
    "middle",
    "middle_name",
    "last",
    "last_name",
    "email",
    "postalcode",
    "fbclid",
    "gclid",
    "msclkid",
    "og1",
    "s1",
    "s2",
    "s3",
    "s4",
    "s5",
    "sub5",
    "subid",
    "tg1",
    "tg2",
    "tg3",
    "tg4",
    "tg5",
    "tg6",
    "tg7",
    "tg8",
    "tg9",
    "tg10",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "vertical",
    "state",
    "zip",
    "zip_1",
    "id",
    "reqid",
  ];

  // Creates an array with params values:
  // ?parameter=value
  // [parameter: "value", ...]
  let params = {};
  const urlString = window.location.href;
  let url = new URL(urlString);
  paramList.forEach(function (key) {
    if (url.searchParams.get(key)) {
      params[key] = url.searchParams.get(key);
    }
  });

  if (0 < Object.keys(params).length) {
    // Checks if object is not empty.
    // Save object in local storage
    try {
      sessionStorage.setItem("cross-page-fields", JSON.stringify(params));
    } catch (error) {
      console.error("Failed to set sessionStorage:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    if ("cross-page-fields" in sessionStorage) {
      const sessionStorageParams = JSON.parse(
        sessionStorage.getItem("cross-page-fields"),
      ); // Retrieve data from local storage
      const processLink = function (href, elem) {
        /* Concat parameters */
        let concat = [];
        for (let key in sessionStorageParams) {
          if ("string" === typeof sessionStorageParams[key]) {
            const paramPresent = href.includes(key);
            if (!paramPresent) {
              // Exception when is `og1`, also passed as `custom2`.
              if ("og1" === key) {
                concat.push("custom2" + "=" + sessionStorageParams[key]);
              }

              // TEST: When a page is tagged as `crm-test` and is a in-content link, will keep `tg1` parameter as defined in the link.
              let elemUrl = new URL(href);
              if (elem) {
                if (
                  "tg1" == key &&
                  elem.matches("article.tag-crm-test p a") &&
                  elemUrl.searchParams.get.tg1
                ) {
                  concat.push(key + "=" + elemUrl.searchParams.get.tg1);
                  continue;
                }
              }

              // Default concatenation.
              concat.push(key + "=" + sessionStorageParams[key]);
            }
          }
        }
        const output = concat.join("&");
        return output;
      };

      /* Concat parameters to links */
      let links = document.getElementsByTagName("a");

      //handle select
      // Get the <select> element by its ID
      let selectElement = document.getElementById(
        "interstitial-selector-select",
      );
      if (selectElement) {
        // Get all <option> elements within the <select>
        let options = selectElement.getElementsByTagName("option");
        for (let i = 0; i < options.length; i++) {
          let option = options[i];
          let url = option.value;

          // Check if the option has a non-empty URL value
          if ("" !== url) {
            // Create a URL object to validate the link
            try {
              let urlObj = new URL(url);
              if ("http:" !== urlObj.protocol && "https:" !== urlObj.protocol) {
                // Invalid protocol, skip this URL
                continue;
              }
              options[i].value =
                urlObj.origin + urlObj.pathname + "?" + processLink(url);
            } catch (error) {
              console.error(error);
              continue;
            }
          }
        }
      }

      // handle links
      for (let i = 0; i < links.length; i++) {
        let elem = links[i];
        let href = elem.href;

        if (!elem.href) {
          continue;
        }

        href = href.replace(/\s+/g, "");
        const classes = elem.className;

        if (
          classes.includes("SPNoConcat") ||
          href.includes("#") ||
          href.includes("unsubscribe") ||
          href.includes("california-privacy-request") ||
          href.includes("data-deletion-request")
        ) {
          // if has anchor or some links, continues to the next link.
          continue;
        }
        let output = processLink(href, elem);

        if (0 < href.indexOf("?")) {
          href = href + "&";
        } else {
          href = href + "?";
        }

        /* Adds '&' beetween each `parameter=value` */
        href = href + output;
        elem.href = href;
      }
    }

    const appendTyParams = function () {
      const appendTyParamElement = document.querySelector(".appendTyParam");

      if (!appendTyParamElement) return;

      // Business logic.
      const handleIntersectionAppendTyParams = function (entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            const tyParamList = [
              "tg1",
              "tg5",
              "tg3",
              "tg7",
              "tg8",
              "tg9",
              "ctx",
              "utm_campaign",
              "utm_content",
              "utm_medium",
              "utm_source",
              "utm_term",
              "email",
              "first_name",
              "last_name",
            ];

            // Get the desired parameter values
            let tg7Value = window.location.hostname;

            // let tg9Value = 'desired_tg9_value';

            let urlHref = window.location.href;
            let url = new URL(urlHref);

            let params = {};

            // Get key and value from the parameters inside the URL.
            tyParamList.forEach(function (key) {
              if (url.searchParams.get(key)) {
                params[key] = url.searchParams.get(key);
              }
            });

            if (0 !== Object.keys(params).length) {
              let links = document.querySelectorAll(".appendTyParam");
              for (let i = 0; i < links.length; i++) {
                // Get the complete link.
                let href = links[i].href;

                // Get the link without the parameters.
                let cleanHref = href.split("?")[0];

                let link = new URL(href);
                let linkParams = new URLSearchParams(link.searchParams);

                // Set the parameters in the array from the URL in the link.
                tyParamList.forEach(function (key) {
                  switch (key) {
                    case "tg7":
                      linkParams.set(key, tg7Value);
                      break;
                    default:
                      if (params[key]) {
                        linkParams.set(key, params[key]);
                      }
                  }
                });

                let newParams = linkParams.toString();

                // Form the new link.
                links[i].setAttribute("href", cleanHref + "?" + newParams);
              }
            }
            appendTyParamsObserver.disconnect();
          }
        });
      };

      const options = {
        threshold: 0,
      };

      const appendTyParamsObserver = new IntersectionObserver(
        handleIntersectionAppendTyParams,
        options,
      );

      appendTyParamsObserver.observe(appendTyParamElement);
    };

    if ("undefined" !== typeof window.IntersectionObserver) {
      try {
        appendTyParams();
      } catch (error) {
        console.error(error);
      }
    }

    const appendLinkAds = function () {
      const appendLinkAdsElements = document.querySelector(
        ".link-ads, .river-link, .litem-link6879, .link-item12, .itemurllink, .item-link2023, .item-link9876, .adz-button-link-3434, .link-item35, .link-ads2344, .river-link, .link-item24, .item-link5678, .link-item14, .adz-item5678, .link-ads234, .link-item2268, .link-adzz, .link-item1268, .adz-item-234765, .link-item46, .link-ads, .item345-link, .link-class, .link-ads23, .adz-item8765, .adz-button, .link-ads22, .adz-button-27864",
      );
      if (!appendLinkAdsElements) return;

      // bussiness logic.
      const handleIntersectionAppendLinkAds = function (entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            linkParamHandler();
            appendLinkAdsObserver.disconnect();
          }
        });
      };

      const options = {
        threshold: 0,
      };

      // create intersection observer.
      const appendLinkAdsObserver = new IntersectionObserver(
        handleIntersectionAppendLinkAds,
        options,
      );

      appendLinkAdsObserver.observe(appendLinkAdsElements);
    };

    //opgguides workaround wip - iteration 0: Make it work specifically in guides scenario.
    if (window.location.hostname.includes("opgguides")) {
      const targets = document.getElementsByClassName("sponsor-link");
      Array.from(targets).forEach((target) => {
        const mutationObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(() => {
              linkParamHandler();
            });
          });
        });
        mutationObserver.observe(target, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      });
    }
    if ("undefined" !== typeof window.IntersectionObserver) {
      try {
        appendLinkAds();
      } catch (error) {
        console.error(error);
      }
    }
  });
})();
